/* GoNaked Hair — Hair Match quiz engine.
   Markup + settings: sections/gnh-hair-quiz.liquid. Product data: sections/gnh-quiz-data.liquid
   (Section Rendering API, so recommendations always reflect live stock, price and sort order). */
(function () {
  'use strict';

  var STORE_KEY = 'gnhHairQuiz.v1';
  var DATA_KEY = 'gnhHairQuizData.v1:';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function lower(s) { return String(s || '').toLowerCase(); }
  function uniq(arr) { var seen = {}; return arr.filter(function (x) { var k = x && x.h ? x.h : x; if (seen[k]) return false; seen[k] = 1; return true; }); }
  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }
  function track(name, data) {
    data = data || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'gnh_quiz_' + name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('gnh_quiz_' + name, data); } catch (e) {}
  }
  function storeGet(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function storeSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function sessGet(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } }
  function sessSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  /* Current URL minus the quiz's own entry params, so UTM and preview params survive history updates. */
  function cleanUrl() {
    var p = new URLSearchParams(location.search);
    ['path', 'from', 'match'].forEach(function (k) { p.delete(k); });
    var q = p.toString();
    return location.pathname + (q ? '?' + q : '');
  }

  /* ---------- hair knowledge ---------- */
  var FAMILY_NAMES = { straight: 'Straight', bodywave: 'Body Wave', wavy: 'Wavy', curly: 'Curly & Deep Wave', kinkystraight: 'Kinky Straight', kinkycurly: 'Kinky Curly' };
  var NEIGHBOURS = { straight: ['kinkystraight'], bodywave: ['wavy'], wavy: ['bodywave', 'curly'], curly: ['wavy', 'kinkycurly'], kinkystraight: ['straight', 'kinkycurly'], kinkycurly: ['curly', 'kinkystraight'] };
  function family(p) {
    var t = lower(p.tx);
    if (!t) {
      var tl = lower(p.t);
      if (/kinky curly|afro kinky|4b|4c|3c-4a/.test(tl)) return 'kinkycurly';
      if (/kinky straight|blowout|yaki/.test(tl)) return 'kinkystraight';
      if (/deep wave|curly|jerry|3b/.test(tl)) return 'curly';
      if (/water wave|ocean wave|beach wave|latin wave|spanish wave|wavy/.test(tl)) return 'wavy';
      if (/body wave|loose wave/.test(tl)) return 'bodywave';
      if (/straight/.test(tl)) return 'straight';
      return null;
    }
    if (/kinky curly|afro/.test(t)) return 'kinkycurly';
    if (/kinky straight|yaki/.test(t)) return 'kinkystraight';
    if (/deep wave|curly|jerry/.test(t)) return 'curly';
    if (/water|ocean|beach|latin|spanish|wavy/.test(t)) return 'wavy';
    if (/body wave|loose wave/.test(t)) return 'bodywave';
    if (/straight/.test(t)) return 'straight';
    return null;
  }
  var SHADES = {
    jetblack: { label: 'Jet black', keys: ['jet-black'] },
    offblack: { label: 'Off black', keys: ['off-black', 'natural-black'] },
    darkbrown: { label: 'Dark brown', keys: ['dark-brown', 'medium-brown'] },
    chocolate: { label: 'Chocolate & chestnut', keys: ['chocolate', 'chestnut', 'medium-brown'] },
    honey: { label: 'Honey blonde', keys: ['honey'] },
    platinum: { label: 'Platinum blonde', keys: ['platinum', '613', 'blonde'] },
    copper: { label: 'Copper & auburn', keys: ['copper', 'auburn'] },
    burgundy: { label: 'Burgundy', keys: ['burgundy'] }
  };
  function shadeOf(p) {
    var h = lower(p.h);
    if (/honey/.test(h)) return 'honey';
    if (/platinum/.test(h) || (/blonde/.test(h) && !/honey/.test(h))) return 'platinum';
    if (/copper|auburn/.test(h)) return 'copper';
    if (/burgundy/.test(h)) return 'burgundy';
    if (/chocolate|chestnut/.test(h)) return 'chocolate';
    if (/dark-brown|medium-brown/.test(h)) return 'darkbrown';
    if (/jet-black/.test(h)) return 'jetblack';
    if (/off-black|natural-black/.test(h)) return 'offblack';
    var cf = lower(p.cf);
    if (cf === 'black' || !cf) return 'offblack';
    if (cf === 'brown') return 'darkbrown';
    if (cf === 'blonde') return 'platinum';
    if (/red|copper/.test(cf)) return 'copper';
    return null;
  }
  function styles(p) { return (p.ws || []).map(lower); }
  function isCollab(p) { return !!p.cb; }

  /* Inches offered by a variant: "22\"" -> [22], "18\"-20\"-22\"" -> [18,20,22] */
  function lengthOpt(p) {
    var idx = -1;
    (p.o || []).forEach(function (n, i) { if (idx < 0 && /length/i.test(n)) idx = i; });
    if (idx < 0) (p.o || []).forEach(function (n, i) { if (idx < 0 && /variant|size/i.test(n)) idx = i; });
    return idx;
  }
  function inches(p, v) {
    var i = lengthOpt(p);
    var src = i >= 0 ? v[1][i] : v[1].join(' ');
    var m = String(src).match(/\d{2}(?=\s*(?:"|”|''|in|inch|-|\/|$|\s))/g) || String(src).match(/\d{2}/g);
    if (!m) { var t = String(p.t).match(/(\d{2})\s*(?:"|”|in)/); return t ? [+t[1]] : []; }
    return m.map(Number).filter(function (n) { return n >= 8 && n <= 40; });
  }
  function maxLen(p, v) { var l = inches(p, v); return l.length ? Math.max.apply(null, l) : null; }
  function productLengths(p) { var out = []; (p.v || []).forEach(function (v) { var m = maxLen(p, v); if (m && out.indexOf(m) < 0) out.push(m); }); return out.sort(function (a, b) { return a - b; }); }

  /* Choose the variant that best fits the shopper's answers. */
  function pickVariant(p, target, prefs) {
    prefs = prefs || {};
    var vs = (p.v || []).slice();
    if (!vs.length) return null;
    var any = vs.some(function (v) { return v[3]; });
    var best = null, bestScore = -1e9;
    vs.forEach(function (v) {
      var s = 0;
      if (any && !v[3]) s -= 1000;
      var len = maxLen(p, v);
      if (target && len) s -= Math.abs(len - target) * 12;
      v[1].forEach(function (val, i) {
        var name = lower((p.o || [])[i]);
        var lv = lower(val).replace(/["”\s]/g, '');
        if (/density/.test(name)) { if (/150/.test(lv)) s += 6; }
        if (/cap/.test(name)) { if (/medium|average|standard/.test(lv)) s += 6; }
        if (/lace/.test(name)) {
          if (prefs.frontal && /13x|frontal/.test(lv)) s += 20;
          if (prefs.frontal === false && !/13x|frontal/.test(lv)) s += 20;
          if (prefs.hd && /hd/.test(lv)) s += 8;
          if (prefs.hd === false && /transparent/.test(lv)) s += 8;
        }
      });
      s -= v[2] / 100000; /* cheapest wins a tie */
      if (s > bestScore) { bestScore = s; best = v; }
    });
    return best;
  }

  /* ---------- the quiz ---------- */
  function Quiz(el) {
    this.el = el;
    var cfgEl = $('[data-gnh-quiz-config]', el);
    this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    this.stage = $('[data-quiz-stage]', el);
    this.live = $('[data-quiz-live]', el);
    this.bar = $('[data-quiz-bar]', el);
    this.counter = $('[data-quiz-count]', el);
    this.backBtn = $('[data-quiz-back]', el);
    this.restartBtn = $('[data-quiz-restart]', el);
    this.head = $('[data-quiz-head]', el);
    this.answers = {};
    this.history = [];
    this.pools = {};
    this.poolPromises = {};
    this.started = false;
    this.questions = this.buildQuestions();
    this.bind();
    this.boot();
  }

  Quiz.prototype.img = function (key) { return (this.cfg.images || {})[key] || ''; };

  Quiz.prototype.buildQuestions = function () {
    var self = this;
    var TEX = [
      { v: 'straight', label: 'Straight', desc: 'Sleek, silky, swingy', img: 'tex_straight' },
      { v: 'bodywave', label: 'Body Wave', desc: 'Soft, glam S-waves', img: 'tex_bodywave' },
      { v: 'wavy', label: 'Wavy', desc: 'Loose, beachy movement', img: 'tex_wavy' },
      { v: 'curly', label: 'Curly & Deep Wave', desc: 'Defined, bouncy curls', img: 'tex_curly' },
      { v: 'kinkystraight', label: 'Kinky Straight', desc: 'Natural blowout texture', img: 'tex_kinkystraight' },
      { v: 'kinkycurly', label: 'Kinky Curly', desc: 'Coily, full, natural', img: 'tex_kinkycurly' }
    ];
    var LENGTHS = [
      { v: 12, label: 'Chin to shoulder', desc: '10–14"', y: 44 },
      { v: 17, label: 'Shoulder to collarbone', desc: '16–18"', y: 56 },
      { v: 21, label: 'Bra strap', desc: '20–22"', y: 68 },
      { v: 25, label: 'Mid-back', desc: '24–26"', y: 80 },
      { v: 30, label: 'Waist & beyond', desc: '28"+', y: 92 }
    ];
    function eff(a) { return a.path === 'unsure' ? ({ fast: 'wig', stylist: 'bundles', ownhair: 'ext', switch: 'wig' })[a.decide] : a.path; }
    this.eff = eff;
    return [
      {
        id: 'path', when: function () { return true; }, layout: 'image',
        eyebrow: 'Let’s begin', title: 'What are we shopping for today?',
        sub: 'Pick one. Every answer narrows it down to the hair we have in stock right now.',
        options: [
          { v: 'wig', label: 'A wig', desc: 'Ready to wear. Headband, glueless & HD lace units.', img: 'path_wig' },
          { v: 'bundles', label: 'Bundles for a sew-in', desc: 'Bundle deals plus the closure or frontal to finish.', img: 'path_bundles' },
          { v: 'lace', label: 'A closure or frontal', desc: 'Finish, refresh or build your own unit.', img: 'path_lace' },
          { v: 'ext', label: 'Extensions', desc: 'Clip-ins, tape-ins, ponytails, crochet & braiding hair.', img: 'path_ext' }
        ],
        extra: { v: 'unsure', label: 'Not sure yet? Help me decide' }
      },
      {
        id: 'decide', when: function (a) { return a.path === 'unsure'; }, layout: 'text',
        eyebrow: 'No wrong answers', title: 'Which sounds most like you?',
        options: [
          { v: 'fast', label: 'I want to look done in minutes', desc: 'No appointments, no glue, no skills required.' },
          { v: 'stylist', label: 'I have a stylist I trust', desc: 'I book installs and want the best hair for them.' },
          { v: 'ownhair', label: 'I love my own hair — I just want more', desc: 'More length, more volume, same me.' },
          { v: 'switch', label: 'I switch my look up constantly', desc: 'New texture Monday, new length Friday.' }
        ]
      },
      {
        id: 'w_exp', when: function (a) { return eff(a) === 'wig'; }, layout: 'text',
        eyebrow: 'About you', title: 'How do you feel about wigs?',
        options: [
          { v: 'first', label: 'This will be my first', desc: 'Keep it simple — I want it to just work.' },
          { v: 'some', label: 'I’ve worn a few', desc: 'Comfortable, still learning the tricks.' },
          { v: 'pro', label: 'I’m a pro', desc: 'I bleach knots and melt my own lace.' },
          { v: 'stylist', label: 'My stylist installs for me', desc: 'I want the best unit to hand over.' }
        ]
      },
      {
        id: 'w_pri', when: function (a) { return eff(a) === 'wig'; }, layout: 'text',
        eyebrow: 'Your non-negotiable', title: 'What matters most in your next unit?',
        options: [
          { v: 'easy', label: 'Zero effort', desc: 'Glueless and headband units. On and out the door.', icon: 'clock' },
          { v: 'natural', label: 'An undetectable hairline', desc: 'HD lace that melts into your skin.', icon: 'eye' },
          { v: 'color', label: 'Statement color', desc: 'Hand-painted balayage, ombré and highlights.', icon: 'spark' },
          { v: 'value', label: 'The most hair for the money', desc: 'Premium virgin hair at the best price.', icon: 'tag' }
        ]
      },
      {
        id: 'l_use', when: function (a) { return eff(a) === 'lace'; }, layout: 'text',
        eyebrow: 'The plan', title: 'What’s it for?',
        options: [
          { v: 'sewin', label: 'Finishing a sew-in', desc: 'Pairing it with bundles.' },
          { v: 'wig', label: 'Making a wig', desc: 'Building a custom unit.' },
          { v: 'refresh', label: 'Replacing an old one', desc: 'Same look, fresh lace.' }
        ]
      },
      {
        id: 'e_type', when: function (a) { return eff(a) === 'ext'; }, layout: 'image', cols: 5,
        eyebrow: 'Extensions', title: 'Which kind of extensions?',
        options: [
          { v: 'clipin', label: 'Clip-ins', desc: 'In and out in minutes.', img: 'ext_clipin' },
          { v: 'tapein', label: 'Tape-ins', desc: 'Flat, discreet, weeks of wear.', img: 'ext_tapein' },
          { v: 'ponytail', label: 'Ponytail', desc: 'Instant length, snatched.', img: 'ext_ponytail' },
          { v: 'crochet', label: 'Feather crochet', desc: 'Human hair crochet, featherlight.', img: 'ext_crochet' },
          { v: 'bulk', label: 'Braiding hair', desc: 'Human hair bulk for boho braids.', img: 'ext_bulk' }
        ]
      },
      {
        id: 'e_nat', when: function (a) { return eff(a) === 'ext' && (a.e_type === 'clipin' || a.e_type === 'tapein'); }, layout: 'text',
        eyebrow: 'Your hair', title: 'What’s your natural hair like?',
        sub: 'Extensions should blend with the hair you already have.',
        options: [
          { v: 'straight', label: 'Straight or relaxed', desc: 'Lies flat, silky' },
          { v: 'wavy', label: 'Wavy', desc: '2A – 2C' },
          { v: 'curly', label: 'Curly', desc: '3A – 3C' },
          { v: 'coily', label: 'Coily', desc: '4A – 4C' },
          { v: 'blowout', label: 'I wear it blown out', desc: 'Stretched, with body' }
        ]
      },
      {
        id: 'texture', when: function (a) { var p = eff(a); return p === 'wig' || p === 'bundles' || p === 'lace' || (p === 'ext' && (a.e_type === 'crochet' || a.e_type === 'bulk')); },
        layout: 'swatch', eyebrow: 'Texture', title: function (a) { return eff(a) === 'ext' ? 'Which texture are you going for?' : 'Pick your texture.'; },
        sub: 'Choose the pattern you want to wear — not necessarily the one you were born with.',
        options: TEX, dynamic: 'texture'
      },
      {
        id: 'l_size', when: function (a) { return eff(a) === 'lace'; }, layout: 'text',
        eyebrow: 'Parting space', title: 'How much lace do you want?',
        help: 'The bigger the lace, the more ways you can part and style — and the more it takes to install. Closures sit on top; frontals run ear to ear.',
        options: [
          { v: '2x6', label: '2x6 closure', desc: 'Deep, sharp middle part.' },
          { v: '4x4', label: '4x4 closure', desc: 'Classic. The easiest install.' },
          { v: '5x5', label: '5x5 closure', desc: 'More room to part. Our best-seller.' },
          { v: '6x6', label: '6x6 & 7x7 closure', desc: 'The frontal look with closure ease.' },
          { v: '13x4', label: '13x4 frontal', desc: 'Ear to ear. Pull-backs and side parts.' },
          { v: '13x6', label: '13x6 frontal', desc: 'The deepest part. Most versatile.' }
        ]
      },
      {
        id: 'length', when: function (a) { var p = eff(a); return p === 'wig' || p === 'bundles' || p === 'lace'; },
        layout: 'length', eyebrow: 'Length', title: function (a) { return eff(a) === 'bundles' ? 'How long do you want your install?' : eff(a) === 'lace' ? 'How long is the hair it’s pairing with?' : 'How long do you want it?'; },
        sub: function (a) { return eff(a) === 'bundles' ? 'This is your longest bundle. We’ll build the other lengths around it.' : 'Measured straight, from the crown down.'; },
        options: LENGTHS
      },
      {
        id: 'w_color', when: function (a) { return eff(a) === 'wig'; }, layout: 'color',
        eyebrow: 'Color', title: 'What color are you drawn to?',
        options: [
          { v: 'black', label: 'Natural black', desc: 'Classic 1B', sw: 'black' },
          { v: 'brunette', label: 'Brunette & balayage', desc: 'Warm, dimensional', sw: 'brunette' },
          { v: 'blonde', label: 'Blonde', desc: 'Honey to icy', sw: 'blonde' },
          { v: 'statement', label: 'Highlights & statement', desc: 'Contrast that turns heads', sw: 'statement' },
          { v: 'open', label: 'Surprise me', desc: 'Show me the best match', sw: 'open' }
        ]
      },
      {
        id: 'w_budget', when: function (a) { return eff(a) === 'wig'; }, layout: 'text',
        eyebrow: 'Budget', title: 'What’s your budget for this unit?',
        sub: 'We’ll match the length you picked to your budget.',
        options: [
          { v: 'b250', label: 'Under $250', desc: 'Headband and bob units live here.' },
          { v: 'b500', label: '$250 – $500', desc: 'Lace fronts and longer lengths.' },
          { v: 'b800', label: '$500 – $800', desc: 'Raw, hand-painted glueless color.' },
          { v: 'blux', label: '$800 and up', desc: 'The showstoppers. Celebrity collab units.' }
        ]
      },
      {
        id: 'b_finish', when: function (a) { return eff(a) === 'bundles'; }, layout: 'text',
        eyebrow: 'The finish', title: 'How do you want to finish your sew-in?',
        options: [
          { v: 'leaveout', label: 'Leave-out', desc: 'Blend your own hair at the front. Bundles only.' },
          { v: 'closure', label: 'Closure', desc: 'The easiest install. Protects your edges, lowest upkeep.' },
          { v: 'frontal', label: 'Frontal', desc: 'Ear-to-ear hairline for pull-backs, side parts and ponytails.' },
          { v: 'unsure', label: 'Not sure — recommend one', desc: 'We’ll suggest the most popular finish.' }
        ]
      },
      {
        id: 'lace', when: function (a) { var p = eff(a); return (p === 'bundles' && a.b_finish && a.b_finish !== 'leaveout') || p === 'lace'; },
        layout: 'text', eyebrow: 'Lace', title: 'HD or transparent lace?',
        help: 'HD lace is thinner and blends into every skin tone with little or no tinting. Transparent lace is light-toned and a touch sturdier — a great value, especially on lighter skin.',
        options: [
          { v: 'hd', label: 'HD lace', desc: 'Ultra-thin. Melts into every skin tone. Our most requested.' },
          { v: 'transparent', label: 'Transparent lace', desc: 'Light-toned, a touch sturdier, easier on the budget.' },
          { v: 'unsure', label: 'Help me choose', desc: 'We’ll go with what melts best.' }
        ]
      },
      {
        id: 'quality', when: function (a) { var p = eff(a); return p === 'bundles' || p === 'lace'; }, layout: 'text',
        eyebrow: 'Hair grade', title: 'Virgin or raw hair?',
        help: 'Both are 100% human hair. Virgin gives you the most quality per dollar and is what most of our customers wear. Raw is unprocessed — buy it when you want hair you can lift, tone and keep in rotation season after season.',
        options: [
          { v: 'virgin', label: 'Virgin hair', desc: 'Our best-seller. Soft, full, the most quality per dollar.' },
          { v: 'raw', label: 'Raw hair', desc: 'Unprocessed. Lift it, tone it, rewear it for seasons.' },
          { v: 'unsure', label: 'Not sure — you pick', desc: 'We’ll recommend based on everything else.' }
        ]
      },
      {
        id: 'b_color', when: function (a) { return eff(a) === 'bundles'; }, layout: 'color', dynamic: 'bcolor',
        eyebrow: 'Color', title: 'Natural black or blonde?',
        options: [
          { v: 'black', label: 'Natural black', desc: '1B · dye-able', sw: 'black' },
          { v: 'blonde', label: 'Blonde', desc: '613 · pre-lightened', sw: 'blonde' }
        ]
      },
      {
        id: 'e_color', when: function (a) { return eff(a) === 'ext' && (a.e_type === 'ponytail' || a.e_type === 'bulk' || (a.e_type === 'clipin' && (a.e_nat === 'straight' || a.e_nat === 'wavy'))); },
        layout: 'color', dynamic: 'shade', eyebrow: 'Shade', title: 'Which shade matches your hair?',
        sub: 'Match your mid-lengths, not your roots.',
        options: [
          { v: 'jetblack', label: 'Jet black', desc: '1', sw: 'jetblack' },
          { v: 'offblack', label: 'Off black', desc: '1B', sw: 'black' },
          { v: 'darkbrown', label: 'Dark brown', desc: '2', sw: 'darkbrown' },
          { v: 'chocolate', label: 'Chocolate & chestnut', desc: '4 – 6', sw: 'chocolate' },
          { v: 'honey', label: 'Honey blonde', desc: '27', sw: 'honey' },
          { v: 'platinum', label: 'Platinum blonde', desc: '613', sw: 'platinum' },
          { v: 'copper', label: 'Copper & auburn', desc: '350', sw: 'copper' },
          { v: 'burgundy', label: 'Burgundy', desc: '99J', sw: 'burgundy' }
        ]
      },
      {
        id: 'e_len', when: function (a) { return eff(a) === 'ext' && (a.e_type === 'crochet' || (a.e_type === 'clipin' && (a.e_nat === 'straight' || a.e_nat === 'wavy'))); },
        layout: 'length', eyebrow: 'Length', title: 'Which length?',
        options: [
          { v: 16, label: '16 inches', desc: 'Collarbone to bra strap', y: 62 },
          { v: 20, label: '20 inches', desc: 'Bra strap to mid-back', y: 76 }
        ]
      }
    ];
  };

  Quiz.prototype.steps = function () {
    var a = this.answers;
    return this.questions.filter(function (q) { return q.when(a); });
  };

  Quiz.prototype.bind = function () {
    var self = this;
    this.backBtn && this.backBtn.addEventListener('click', function () { self.back(); });
    this.restartBtn && this.restartBtn.addEventListener('click', function () { self.restart(); });
    window.addEventListener('popstate', function (e) {
      var st = e.state && e.state.gnhQuiz;
      if (!st) { if (self.history.length) self.goto(0, true); return; }
      self.answers = st.answers || {};
      if (st.view === 'results') self.showResults(true);
      else self.goto(st.index || 0, true);
    });
    this.el.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-opt]');
      if (opt && self.el.contains(opt)) { e.preventDefault(); self.choose(opt); return; }
      var act = e.target.closest('[data-act]');
      if (act) { self.action(act.getAttribute('data-act'), act, e); }
    });
    this.el.addEventListener('keydown', function (e) {
      var opt = e.target.closest && e.target.closest('[role="radio"]');
      if (!opt) return;
      var group = opt.closest('[role="radiogroup"]');
      var items = $$('[role="radio"]', group);
      var i = items.indexOf(opt), n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = items[(i + 1) % items.length];
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = items[(i - 1 + items.length) % items.length];
      if (n) { e.preventDefault(); items.forEach(function (x) { x.tabIndex = -1; }); n.tabIndex = 0; n.focus(); }
    });
    this.el.addEventListener('change', function (e) {
      if (e.target.matches('[data-variant-select]')) self.onVariantChange(e.target);
      if (e.target.matches('[data-set-toggle]')) self.updateSetTotal();
    });
    this.el.addEventListener('submit', function (e) {
      if (e.target.matches('[data-quiz-email]')) { e.preventDefault(); self.submitEmail(e.target); }
    });
  };

  Quiz.prototype.boot = function () {
    var params = new URLSearchParams(location.search);
    var shared = params.get('match');
    if (shared) {
      var dec = this.decode(shared);
      if (dec) { this.answers = dec; this.shared = true; this.showResults(false, true); return; }
    }
    var saved = storeGet(STORE_KEY);
    var pre = params.get('path');
    if (pre && ['wig', 'bundles', 'lace', 'ext', 'unsure'].indexOf(pre) > -1) {
      this.answers = { path: pre };
      history.replaceState({ gnhQuiz: { index: 0, answers: { path: pre }, view: 'question' } }, '', cleanUrl());
      this.start('entry:' + (params.get('from') || 'link'));
      this.prefetch();
      this.goto(1);
      return;
    }
    this.saved = saved && saved.answers && saved.done ? saved : null;
    if (params.get('from')) this.start('entry:' + params.get('from'));
    this.goto(0, true);
  };

  Quiz.prototype.start = function (src) {
    if (this.started) return;
    this.started = true;
    track('start', { source: src || 'page' });
  };

  /* ---------- rendering questions ---------- */
  Quiz.prototype.text = function (v) { return typeof v === 'function' ? v(this.answers) : v; };

  Quiz.prototype.goto = function (index, fromHistory) {
    var steps = this.steps();
    index = clamp(index, 0, steps.length - 1);
    var q = steps[index];
    this.index = index;
    this.currentId = q.id;
    this.view = 'question';
    if (!fromHistory) history.pushState({ gnhQuiz: { index: index, answers: this.answers, view: 'question' } }, '', cleanUrl());
    else if (!history.state) history.replaceState({ gnhQuiz: { index: index, answers: this.answers, view: 'question' } }, '', cleanUrl());
    this.el.setAttribute('data-view', 'question');
    this.el.setAttribute('data-step', q.id);
    this.renderProgress(index, steps.length);
    this.swap(this.renderQuestion(q, index), q);
  };

  Quiz.prototype.renderProgress = function (index, total) {
    /* Front-loaded progress (fast early, slower late) keeps people going. */
    var done = total > 1 ? index / (total) : 0;
    var shown = Math.pow(done, 0.72);
    if (this.bar) this.bar.style.transform = 'scaleX(' + (0.04 + shown * 0.96).toFixed(3) + ')';
    if (this.counter) this.counter.innerHTML = index === 0 ? 'About 60 seconds' : '<span class="gnhq__cq">Question </span>' + (index + 1) + ' of ' + total;
    if (this.backBtn) this.backBtn.hidden = index === 0 && this.view !== 'email';
  };

  Quiz.prototype.optionAvailable = function (q, o) {
    var a = this.answers, pool, path = this.eff(a);
    if (!q.dynamic) return true;
    var key = this.poolKey();
    pool = this.pools[key];
    if (!pool) return true; /* data not loaded yet: show everything */
    var kinds = { wig: ['wig'], bundles: ['deal', 'bundle'], lace: ['closure', 'frontal'], ext: [a.e_type] }[path] || [];
    var items = pool.filter(function (p) { return kinds.indexOf(p.k) > -1 && p.a; });
    if (q.dynamic === 'texture') return items.some(function (p) { return family(p) === o.v; });
    if (q.dynamic === 'bcolor') {
      var fam = a.texture;
      return items.some(function (p) { return family(p) === fam && (o.v === 'blonde' ? lower(p.cf) === 'blonde' : lower(p.cf) !== 'blonde'); });
    }
    if (q.dynamic === 'shade') return items.some(function (p) { return shadeOf(p) === o.v; });
    return true;
  };

  Quiz.prototype.renderQuestion = function (q, index) {
    var self = this, a = this.answers;
    var opts = q.options.filter(function (o) { return self.optionAvailable(q, o); });
    /* A dynamic question left with one real choice answers itself. */
    q._auto = q.dynamic && this.pools[this.poolKey()] && opts.length === 1 ? opts[0].v : null;
    var layout = q.layout;
    var cur = a[q.id];
    var titleId = 'gnhq-t-' + q.id;
    var html = '<div class="gnhq__q gnhq__q--' + layout + '">';
    html += '<header class="gnhq__qhead">';
    if (q.eyebrow) html += '<p class="gnhq__eyebrow">' + esc(this.text(q.eyebrow)) + '</p>';
    html += '<h2 class="gnhq__title" id="' + titleId + '" tabindex="-1">' + esc(this.text(q.title)) + '</h2>';
    if (q.sub) html += '<p class="gnhq__sub">' + esc(this.text(q.sub)) + '</p>';
    html += '</header>';
    var cols = q.cols || (layout === 'image' ? 4 : layout === 'swatch' ? Math.min(opts.length, 6) : layout === 'length' ? opts.length : layout === 'color' ? Math.min(opts.length, 5) : (opts.length === 3 ? 3 : 2));
    html += '<div class="gnhq__opts gnhq__opts--' + layout + '" role="radiogroup" aria-labelledby="' + titleId + '" style="--cols:' + cols + '">';
    opts.forEach(function (o, i) {
      var sel = String(cur) === String(o.v);
      var tab = sel || (cur == null && i === 0) ? 0 : -1;
      html += '<button type="button" class="gnhq__opt" role="radio" aria-checked="' + sel + '" tabindex="' + tab + '" data-opt data-q="' + q.id + '" data-v="' + esc(o.v) + '">';
      html += self.renderOptionInner(q, o, layout);
      html += '<span class="gnhq__check" aria-hidden="true"><svg viewBox="0 0 16 16"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
      html += '</button>';
    });
    html += '</div>';
    if (q.extra) html += '<div class="gnhq__extra"><button type="button" class="gnhq__textlink" data-opt data-q="' + q.id + '" data-v="' + esc(q.extra.v) + '">' + esc(q.extra.label) + ' <span aria-hidden="true">&rarr;</span></button></div>';
    if (q.help) html += '<details class="gnhq__help"><summary>What’s the difference?</summary><p>' + esc(q.help) + '</p></details>';
    if (index === 0 && this.saved) {
      html += '<div class="gnhq__resume"><span>Welcome back — your last match is saved.</span><button type="button" class="gnhq__textlink" data-act="resume">See my match <span aria-hidden="true">&rarr;</span></button></div>';
    }
    html += '</div>';
    return html;
  };

  Quiz.prototype.renderOptionInner = function (q, o, layout) {
    var h = '';
    if (layout === 'image') {
      var src = this.img(o.img);
      h += '<span class="gnhq__media">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="600" height="750">' : '') + '</span>';
      h += '<span class="gnhq__label">' + esc(o.label) + '</span><span class="gnhq__desc">' + esc(o.desc) + '</span>';
    } else if (layout === 'swatch') {
      var t = (this.cfg.textures || {})[o.v] || {};
      h += '<span class="gnhq__swatch" style="--zoom:' + (t.zoom || 2.2) + ';--fy:' + (t.focus || 50) + '%">' + (t.src ? '<img src="' + esc(t.src) + '" alt="" loading="lazy" width="300" height="300">' : '') + '</span>';
      h += '<span class="gnhq__label">' + esc(o.label) + '</span><span class="gnhq__desc">' + esc(o.desc) + '</span>';
    } else if (layout === 'length') {
      h += '<span class="gnhq__figure" aria-hidden="true">' + this.figure(o.y) + '</span>';
      h += '<span class="gnhq__label">' + esc(o.label) + '</span><span class="gnhq__desc">' + esc(o.desc) + '</span>';
    } else if (layout === 'color') {
      h += '<span class="gnhq__dot gnhq__dot--' + esc(o.sw) + '" aria-hidden="true"></span>';
      h += '<span class="gnhq__label">' + esc(o.label) + '</span><span class="gnhq__desc">' + esc(o.desc) + '</span>';
    } else {
      if (o.icon) h += '<span class="gnhq__icon" aria-hidden="true">' + this.icon(o.icon) + '</span>';
      h += '<span class="gnhq__tbody"><span class="gnhq__label">' + esc(o.label) + '</span>' + (o.desc ? '<span class="gnhq__desc">' + esc(o.desc) + '</span>' : '') + '</span>';
    }
    return h;
  };

  Quiz.prototype.icon = function (n) {
    var p = {
      clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
      eye: '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="2.8"/>',
      spark: '<path d="M12 3v5M12 16v5M3 12h5M16 12h5M6 6l3 3M15 15l3 3M18 6l-3 3M9 15l-3 3"/>',
      tag: '<path d="M3.5 12.5l8-8H20v8.5l-8 8z"/><circle cx="16" cy="8" r="1.3"/>'
    }[n] || '';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">' + p + '</svg>';
  };

  /* Minimal line-art bust; hair falls to y (40 = chin, 96 = waist). */
  Quiz.prototype.figure = function (y) {
    var hy = y, c = hy + 5;
    return '<svg viewBox="0 0 64 100" fill="none">' +
      '<path class="gnhq__fig-body" d="M22 46c3 3 7 4 10 4s7-1 10-4l10 5c5 3 7 8 7 14v35H5V65c0-6 2-11 7-14z"/>' +
      '<path class="gnhq__fig-hair" d="M32 6c-10 0-15 8-15 18 0 5-1 9-2 13v' + (hy - 37) + 'c3 3 8 ' + (c - hy) + ' 11 0V32c0-8 2-15 6-15s6 7 6 15v' + (hy - 32) + 'c3 ' + (c - hy) + ' 8 ' + (c - hy) + ' 11 0V37c-1-4-2-8-2-13C47 14 42 6 32 6z"/>' +
      '<ellipse class="gnhq__fig-face" cx="32" cy="26" rx="7.5" ry="10"/>' +
      '<line class="gnhq__fig-mark" x1="2" x2="62" y1="' + hy + '" y2="' + hy + '"/>' +
      '</svg>';
  };

  Quiz.prototype.swap = function (html, q) {
    var self = this, stage = this.stage;
    var run = function () {
      stage.innerHTML = html;
      stage.classList.remove('is-out');
      stage.classList.add('is-in');
      var t = $('.gnhq__title', stage) || $('[tabindex="-1"]', stage);
      if (self.didInteract && t) t.focus({ preventScroll: true });
      if (self.live && q) self.live.textContent = self.text(q.title);
      if (self.didInteract) {
        var top = self.el.getBoundingClientRect().top + window.pageYOffset - self.headerOffset();
        if (window.pageYOffset > top) window.scrollTo({ top: Math.max(0, top), behavior: REDUCED ? 'auto' : 'smooth' });
      }
      requestAnimationFrame(function () { stage.classList.remove('is-in'); });
    };
    if (REDUCED || !stage.children.length) return run();
    stage.classList.add('is-out');
    setTimeout(run, 180);
  };

  /* Height of Dawn's sticky header so scrolled-to steps never sit underneath it. */
  Quiz.prototype.headerOffset = function () {
    var h = document.querySelector('sticky-header, .header-wrapper');
    var r = h ? h.getBoundingClientRect() : null;
    return (r && r.height ? Math.min(r.height, 200) : 80) + 16;
  };

  Quiz.prototype.choose = function (btn) {
    var self = this, qid = btn.getAttribute('data-q');
    var raw = btn.getAttribute('data-v');
    var val = /^\d+$/.test(raw) ? +raw : raw;
    this.didInteract = true;
    var q = this.questions.filter(function (x) { return x.id === qid; })[0];
    if (!q) return;
    if (qid === 'path') this.start('page');
    /* changing an earlier answer clears answers that depended on it */
    var prev = this.answers[qid];
    this.answers[qid] = val;
    if (prev !== val) this.prune();
    $$('[data-q="' + qid + '"][role="radio"]', this.stage).forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
    btn.classList.add('is-picked');
    track('answer', { question: qid, answer: String(val), step: this.index + 1 });
    if (qid === 'path' || qid === 'decide' || qid === 'e_type') this.prefetch();
    setTimeout(function () { self.next(); }, REDUCED ? 60 : 320);
  };

  Quiz.prototype.prune = function () {
    var keep = {}, a = this.answers;
    this.questions.forEach(function (q) { if (q.when(a) && a[q.id] != null) keep[q.id] = a[q.id]; });
    this.answers = keep;
  };

  Quiz.prototype.next = function () {
    var steps = this.steps();
    var ids = steps.map(function (q) { return q.id; });
    var i = ids.indexOf(this.currentId) + 1;
    if (i <= 0) i = this.index + 1;
    /* auto-answer dynamic questions with only one valid option */
    while (i < steps.length) {
      var q = steps[i];
      var probe = this.renderQuestion(q, i) && q._auto;
      if (probe != null) { this.answers[q.id] = probe; steps = this.steps(); i++; continue; }
      break;
    }
    if (i >= steps.length) return this.finish();
    this.goto(i);
  };

  Quiz.prototype.back = function () {
    if (this.view === 'question' && this.index === 0) return;
    history.back();
  };

  Quiz.prototype.restart = function () {
    this.answers = {};
    this.didInteract = true;
    this.saved = null;
    track('restart', {});
    this.goto(0);
  };

  Quiz.prototype.action = function (name, el, e) {
    if (name === 'resume') { this.answers = this.saved.answers; this.showResults(); }
    if (name === 'skip-email') { track('email_skip', {}); this.emailSkipped = true; this.showResults(); }
    if (name === 'retake') { this.restart(); }
    if (name === 'edit') { this.didInteract = true; var idx = +el.getAttribute('data-index'); this.goto(idx); }
    if (name === 'add') { e.preventDefault(); this.addToCart(el); }
    if (name === 'add-set') { e.preventDefault(); this.addSet(el); }
    if (name === 'share') { e.preventDefault(); this.share(el); }
  };

  /* ---------- data ---------- */
  Quiz.prototype.poolKey = function () {
    var p = this.eff(this.answers);
    return p || 'none';
  };
  Quiz.prototype.sourcesFor = function (key) {
    var s = (this.cfg.sources || {})[key] || [];
    return s;
  };
  Quiz.prototype.prefetch = function () {
    var key = this.poolKey();
    if (!key || key === 'none' || this.poolPromises[key]) return this.poolPromises[key];
    var self = this;
    var cached = sessGet(DATA_KEY + key);
    if (cached && Date.now() - cached.t < 10 * 60 * 1000) {
      this.pools[key] = cached.d;
      return (this.poolPromises[key] = Promise.resolve(cached.d));
    }
    var urls = this.sourcesFor(key);
    var jobs = urls.map(function (u) {
      var url = u + (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=gnh-quiz-data';
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var m = html.match(/<script[^>]*data-gnh-quiz-data[^>]*>([\s\S]*?)<\/script>/);
        if (!m) return [];
        try { return JSON.parse(m[1]); } catch (e) { return []; }
      }).catch(function () { return []; });
    });
    this.poolPromises[key] = Promise.all(jobs).then(function (lists) {
      var all = [];
      lists.forEach(function (list, li) { list.forEach(function (p) { p.src = li; all.push(p); }); });
      all = uniq(all);
      self.pools[key] = all;
      sessSet(DATA_KEY + key, { t: Date.now(), d: all });
      return all;
    });
    return this.poolPromises[key];
  };

  /* ---------- scoring ---------- */
  function Scored(p, v) { this.p = p; this.v = v; this.s = 0; this.why = []; }
  Scored.prototype.add = function (n, why) { this.s += n; if (why && n > 0) this.why.push({ n: n, t: why }); };

  Quiz.prototype.baseline = function (sc) {
    var p = sc.p;
    if (!p.a) sc.add(-400);
    sc.add(Math.max(0, 14 - (p.r || 99) * 0.45)); /* best-selling order */
    if (p.rt && p.rc > 2) sc.add((p.rt - 4) * 8, p.rc >= 10 ? p.rt.toFixed(1) + '★ from ' + p.rc + ' reviews' : null);
  };

  Quiz.prototype.texScore = function (sc, want, weight) {
    var f = family(sc.p);
    weight = weight || 40;
    if (!want) return;
    if (f === want) sc.add(weight, FAMILY_NAMES[want] + ' — the texture you picked');
    else if (!f) sc.add(weight * 0.25);
    else if ((NEIGHBOURS[want] || []).indexOf(f) > -1) sc.add(-weight * 0.35);
    else sc.add(-weight * 1.3);
  };

  Quiz.prototype.lenScore = function (sc, target, why) {
    if (!target || !sc.v) return;
    var len = maxLen(sc.p, sc.v);
    if (!len) return;
    var d = Math.abs(len - target);
    if (d <= 2) sc.add(14, why !== false ? 'Available at ' + len + '" — ' + (this.lenLabel(target) || 'your length') : null);
    else sc.add(-d * 3);
  };
  Quiz.prototype.lenLabel = function (t) {
    return { 12: 'chin to shoulder', 17: 'shoulder length', 21: 'bra-strap length', 25: 'mid-back length', 30: 'waist length', 16: 'collarbone length', 20: 'mid-back length' }[t];
  };

  Quiz.prototype.rank = function (list) { return list.sort(function (a, b) { return b.s - a.s; }); };

  Quiz.prototype.recommend = function () {
    var a = this.answers, path = this.eff(a);
    var pool = this.pools[this.poolKey()] || [];
    if (path === 'wig') return this.recWig(pool, a);
    if (path === 'bundles') return this.recBundles(pool, a);
    if (path === 'lace') return this.recLace(pool, a);
    if (path === 'ext') return this.recExt(pool, a);
    return null;
  };

  Quiz.prototype.recWig = function (pool, a) {
    var self = this;
    var budget = { b250: [0, 250], b500: [250, 500], b800: [500, 800], blux: [800, 99999] }[a.w_budget] || [0, 99999];
    var wigs = pool.filter(function (p) { return p.k === 'wig'; });
    var scored = wigs.map(function (p) {
      var prefs = { frontal: a.w_pri === 'natural' || a.w_exp === 'pro' || a.w_exp === 'stylist' ? true : (a.w_pri === 'easy' || a.w_exp === 'first' ? false : null), hd: true };
      var v = pickVariant(p, a.length, prefs);
      var sc = new Scored(p, v);
      var st = styles(p), cf = lower(p.cf), d = lower(p.d), price = v ? v[2] / 100 : p.p / 100;
      var glueless = st.indexOf('glueless') > -1, headband = st.indexOf('headband') > -1, lacefront = st.indexOf('lace front') > -1, hd = lower(p.lt) === 'hd';
      self.baseline(sc);
      self.texScore(sc, a.texture, 42);
      self.lenScore(sc, a.length);
      /* priority */
      if (a.w_pri === 'easy') {
        if (headband) sc.add(34, 'Headband wig — no lace, no glue, on in under five minutes');
        if (glueless) sc.add(32, 'Glueless fit — secure without adhesive');
        if (lacefront && !glueless) sc.add(-8);
      } else if (a.w_pri === 'natural') {
        if (hd) sc.add(26, 'HD lace that disappears into every skin tone');
        if (isCollab(p)) sc.add(16, 'Choose the 13x6 frontal for the deepest, most natural part');
        else if (lacefront) sc.add(14, 'Lace front for a realistic hairline');
        if (glueless && hd) sc.add(6);
        if (headband) sc.add(-18);
      } else if (a.w_pri === 'color') {
        if (/balayage|ombr|highlight/.test(cf)) sc.add(28, 'Hand-painted color by a professional colorist');
        else if (cf && cf !== 'black') sc.add(20, 'Color done for you — no salon visit needed');
        if (isCollab(p)) sc.add(10, a.w_budget === 'blux' ? null : 'A celebrity collab unit — worn on RHOA');
        if (cf === 'black') sc.add(-20);
      } else if (a.w_pri === 'value') {
        sc.add(clamp(30 * (1 - price / 700), -20, 30), price < 300 ? 'Premium virgin hair at our best price' : null);
      }
      /* experience */
      if (a.w_exp === 'first') { if (headband || glueless) sc.add(16, 'Beginner-friendly — nothing to cut, glue or melt'); if (lacefront && !glueless) sc.add(-10); }
      if (a.w_exp === 'pro') { if (lacefront) sc.add(10); if (hd) sc.add(6); if (headband) sc.add(-8); }
      if (a.w_exp === 'stylist') { if (lacefront) sc.add(10, 'Lace front your stylist can customize'); if (isCollab(p)) sc.add(6); }
      /* colour */
      var c = a.w_color;
      if (c === 'black') { if (cf === 'black') sc.add(28, 'Natural black, ready to wear or dye'); else if (cf) sc.add(-45); else sc.add(-8); }
      if (c === 'brunette') { if (/balayage|ombr/.test(cf)) sc.add(28, 'Dimensional brunette balayage'); else if (cf === 'highlighted') sc.add(14); else if (cf === 'black') sc.add(2); else if (cf === 'blonde') sc.add(-14); if (/brunette|chocolate|caramel|chestnut/.test(d)) sc.add(10); if (/blonde lengths|creamy blonde|platinum/.test(d)) sc.add(-6); }
      if (c === 'blonde') { if (cf === 'blonde') sc.add(38, 'Blonde, already toned for you'); else if (/balayage|ombr/.test(cf)) sc.add(/blonde/.test(d) ? 24 : 8, /blonde/.test(d) ? 'Blonde ombré painted by hand' : null); else if (cf === 'highlighted') sc.add(12); else if (cf === 'black') sc.add(-38); }
      if (c === 'statement') { if (cf === 'highlighted') sc.add(34, 'High-contrast highlights that turn heads'); else if (/balayage|ombr/.test(cf)) sc.add(26, 'Hand-painted balayage'); else if (cf === 'blonde') sc.add(20); else if (cf === 'black') sc.add(-22); if (/money piece|copper|bold/.test(d)) sc.add(8); }
      /* budget at the length you picked */
      if (price >= budget[0] && price <= budget[1]) sc.add(22, a.w_budget === 'blux' ? null : 'Fits your budget at the length you picked');
      else if (price < budget[0]) sc.add(a.w_budget === 'blux' ? -16 : 4);
      else sc.add(-clamp((price - budget[1]) / budget[1] * 110, 8, 70));
      if (a.w_budget === 'blux' && isCollab(p)) sc.add(18, 'Our celebrity collab line — worn on the RHOA reunion');
      return sc;
    });
    this.rank(scored);
    var top = scored[0];
    if (!top) return null;
    var alts = this.pickAlts(scored, top, function (x) { return x.v ? x.v[2] : x.p.p; });
    var persona = { easy: ['The Effortless Icon', 'You want to look finished in minutes, every time. These units do the work for you.'], natural: ['The Flawless Melt', 'Nobody should be able to tell. Your match is built around the most natural hairline we make.'], color: ['The Statement Maker', 'You want the room to notice. Your match is hand-painted color that looks expensive — because it is.'], value: ['The Smart Luxe', 'Premium hair without the premium markup. Your match is where quality meets the best price.'] }[a.w_pri] || ['Your Hair Match', ''];
    return { persona: persona, primary: top, alts: alts, addons: ['edge'], browse: this.cfg.browse && this.cfg.browse.wig };
  };

  /* Alternatives: one cheaper, one step up, one wildcard; never duplicates. */
  Quiz.prototype.pickAlts = function (scored, top, price) {
    var rest = scored.filter(function (x) { return x !== top && x.p.a && x.s > top.s - 230; });
    var tp = price(top);
    var used = {};
    used[top.p.h] = 1;
    var out = [];
    function take(fn, label, note) {
      for (var i = 0; i < rest.length; i++) { var x = rest[i]; if (used[x.p.h]) continue; if (fn(x)) { used[x.p.h] = 1; out.push({ sc: x, label: label, note: note }); return; } }
    }
    var floor = top.s - 120;
    take(function (x) { return x.s > floor && price(x) < tp * 0.85; }, 'Best value', 'Similar look, easier on the budget');
    take(function (x) { return x.s > floor && price(x) > tp * 1.12; }, 'The upgrade', 'More luxe hair or more lace');
    var topStyle = (top.p.ws || []).join() + family(top.p);
    take(function (x) { return x.s > floor && (x.p.ws || []).join() + family(x.p) !== topStyle; }, 'Also a match', 'A different take on your answers');
    while (out.length < 3) { var n = out.length; take(function (x) { return x.s > top.s - 80; }, 'Also a match', 'Another strong fit for your answers'); if (out.length === n) break; }
    return out.slice(0, 3);
  };

  Quiz.prototype.recBundles = function (pool, a) {
    var self = this;
    var wantRaw = a.quality === 'raw', unsureQ = a.quality === 'unsure' || !a.quality;
    var blonde = a.b_color === 'blonde';
    var L = a.length || 21;
    function qualityScore(sc, weight) {
      var q = lower(sc.p.q);
      if (unsureQ) { if (q === 'virgin') sc.add(weight * 0.4, 'Virgin — our best-selling grade'); return; }
      if ((wantRaw && q === 'raw') || (!wantRaw && q === 'virgin')) sc.add(weight, wantRaw ? 'Raw hair — unprocessed, built to last' : 'Virgin hair — the most quality per dollar');
      else sc.add(-weight * 0.8);
    }
    function colorScore(sc) { var isB = lower(sc.p.cf) === 'blonde' || /blonde/.test(lower(sc.p.h)); if (blonde) sc.add(isB ? 30 : -40, isB ? 'Blonde (613), ready to tone' : null); else sc.add(isB ? -40 : 6); }
    var deals = pool.filter(function (p) { return p.k === 'deal'; }).map(function (p) {
      var v = pickVariant(p, L);
      var sc = new Scored(p, v);
      self.baseline(sc); self.texScore(sc, a.texture, 50); qualityScore(sc, 26); colorScore(sc); self.lenScore(sc, L, false);
      return sc;
    });
    var singles = pool.filter(function (p) { return p.k === 'bundle'; }).map(function (p) {
      var v = pickVariant(p, L);
      var sc = new Scored(p, v);
      self.baseline(sc); self.texScore(sc, a.texture, 50); qualityScore(sc, 26); colorScore(sc); self.lenScore(sc, L, false);
      return sc;
    });
    this.rank(deals); this.rank(singles);
    var deal = deals[0] && family(deals[0].p) === a.texture ? deals[0] : null;
    var single = singles[0] || null;
    var set = [];
    if (deal && deal.s > -100) {
      var dl = inches(deal.p, deal.v);
      deal.why.unshift({ n: 99, t: 'Three bundles' + (dl.length ? ' in ' + dl.join('", ') + '"' : '') + ' — bundled at a lower price than buying separately' });
      set.push({ sc: deal, qty: 1, role: 'Bundles', checked: true });
    } else if (single) {
      /* No 3-pack in this texture: build one from single bundles, longest last. */
      var lens = productLengths(single.p);
      var picks = [L - 4, L - 2, L].map(function (t) { return pickVariant(single.p, t); });
      picks.forEach(function (v, i) { set.push({ sc: Object.assign(new Scored(single.p, v), { why: single.why }), qty: 1, role: i === 0 ? 'Bundles' : '', checked: true }); });
      single.why.unshift({ n: 99, t: 'Three lengths hand-picked for a full, blended install' });
    }
    var lead = set.length ? set[0].sc : null;
    if (!lead) return null;
    /* 26"+ installs look fuller with a fourth bundle */
    if (L >= 25 && single) {
      var v4 = pickVariant(single.p, L);
      set.push({ sc: new Scored(single.p, v4), qty: 1, role: 'Fourth bundle', checked: true, note: 'For 24"+ installs most stylists use four bundles for fullness to the ends.' });
    }
    /* the finish */
    var finish = a.b_finish === 'unsure' ? 'closure' : a.b_finish;
    var piece = null, pieceAlt = null;
    if (finish === 'closure' || finish === 'frontal') {
      var pieces = this.scoreLace(pool, a, { kind: finish, size: finish === 'closure' ? '5x5' : '13x4', target: L >= 24 ? Math.min(L - 4, 20) : L - 2 });
      piece = pieces[0];
      if (piece) {
        var roleName = finish === 'closure' ? 'Closure' : 'Frontal';
        set.push({ sc: piece, qty: 1, role: roleName, checked: true });
      }
      var otherKind = finish === 'closure' ? 'frontal' : 'closure';
      pieceAlt = this.scoreLace(pool, a, { kind: otherKind, size: otherKind === 'closure' ? '5x5' : '13x4', target: L - 2 })[0];
    }
    set.push({ addon: 'edge', role: 'Finish', checked: false });
    var alts = [];
    if (single && deal && single.p.a) alts.push({ sc: single, label: 'Build your own', note: 'Single bundles — mix any lengths you like' });
    var otherGrade = deals.filter(function (x) { return x !== deal && x.p.a && family(x.p) === a.texture && lower(x.p.q) !== lower(deal ? deal.p.q : ''); })[0];
    if (otherGrade) alts.push({ sc: otherGrade, label: lower(otherGrade.p.q) === 'raw' ? 'The upgrade' : 'Best value', note: lower(otherGrade.p.q) === 'raw' ? 'Raw hair — longest lifespan, lifts beautifully' : 'Virgin hair — same texture, lower price' });
    if (pieceAlt) alts.push({ sc: pieceAlt, label: finish === 'closure' ? 'Want more versatility?' : 'Want an easier install?', note: finish === 'closure' ? 'A frontal gives you pull-backs and side parts' : 'A closure installs faster and needs less upkeep' });
    if (alts.length < 3) { var more = deals.filter(function (x) { return x !== deal && alts.every(function (y) { return y.sc !== x; }) && x.p.a; })[0]; if (more) alts.push({ sc: more, label: 'Also loved', note: 'Another best-selling texture' }); }
    var persona = { leaveout: ['The Natural Blend', 'Your own hair out front, our bundles everywhere else — the most seamless sew-in there is.'], closure: ['The Low-Maintenance Queen', 'A full, protective install that looks done every morning with almost no upkeep.'], frontal: ['The Versatile Glam', 'Ear-to-ear lace so you can part it, pull it back and switch it up all install long.'] }[finish] || ['Your Sew-In Match', ''];
    return { persona: persona, primary: lead, set: set, alts: alts.slice(0, 3), browse: this.cfg.browse && this.cfg.browse.bundles };
  };

  Quiz.prototype.scoreLace = function (pool, a, o) {
    var self = this;
    var wantHd = a.lace !== 'transparent';
    var wantRaw = a.quality === 'raw', unsureQ = a.quality === 'unsure' || !a.quality;
    var blonde = a.b_color === 'blonde';
    var list = pool.filter(function (p) { return o.kind === 'any' ? (p.k === 'closure' || p.k === 'frontal') : p.k === o.kind; }).map(function (p) {
      var v = pickVariant(p, o.target);
      var sc = new Scored(p, v);
      var sizes = (p.ls || []).map(lower), lt = lower(p.lt), q = lower(p.q);
      if (!sizes.length) { var m = lower(p.t).match(/(\d{1,2}x\d)/); if (m) sizes = [m[1]]; }
      self.baseline(sc);
      self.texScore(sc, a.texture, 46);
      if (o.size) {
        var want = o.size === '6x6' ? ['6x6', '7x7'] : [o.size];
        if (sizes.some(function (s) { return want.indexOf(s) > -1; })) sc.add(30, sizes[0] + ' ' + (p.k === 'frontal' ? 'frontal' : 'closure') + ' — ' + ({ '2x6': 'a deep, sharp middle part', '4x4': 'the easiest install', '5x5': 'extra room to part', '6x6': 'the frontal look with closure ease', '7x7': 'the frontal look with closure ease', '13x4': 'ear-to-ear coverage', '13x6': 'the deepest, most versatile part' }[sizes[0]] || 'the size you picked'));
        else sc.add(-12);
      }
      if (lt) { if ((lt === 'hd') === wantHd) sc.add(22, wantHd ? 'HD lace — melts into every skin tone' : 'Transparent lace — sturdy and budget-friendly'); else sc.add(-14); }
      if (!unsureQ) { if ((wantRaw && q === 'raw') || (!wantRaw && q === 'virgin')) sc.add(16, wantRaw ? 'Raw hair to match raw bundles' : 'Virgin hair to match your bundles'); else sc.add(-12); }
      var isB = lower(p.cf) === 'blonde';
      sc.add(blonde ? (isB ? 40 : -90) : (isB ? -60 : 0), blonde && isB ? 'Blonde lace piece to match blonde bundles' : null);
      self.lenScore(sc, o.target, false);
      return sc;
    });
    return this.rank(list);
  };

  Quiz.prototype.recLace = function (pool, a) {
    var size = a.l_size || '5x5';
    var kind = /^13x/.test(size) ? 'frontal' : 'closure';
    var list = this.scoreLace(pool, a, { kind: kind, size: size, target: a.length });
    var top = list[0];
    if (!top) return null;
    var everything = this.scoreLace(pool, a, { kind: 'any', size: null, target: a.length });
    var alts = [];
    var used = {}; used[top.p.h] = 1;
    function take(arr, fn, label, note) { for (var i = 0; i < arr.length; i++) { var x = arr[i]; if (!used[x.p.h] && x.p.a && fn(x)) { used[x.p.h] = 1; alts.push({ sc: x, label: label, note: note }); return; } } }
    var tSize = (top.p.ls || [])[0];
    take(list, function (x) { return lower(x.p.lt) !== lower(top.p.lt); }, lower(top.p.lt) === 'hd' ? 'Best value' : 'The upgrade', lower(top.p.lt) === 'hd' ? 'Same size in transparent lace' : 'Same size in HD lace');
    take(everything, function (x) { return (x.p.ls || [])[0] !== tSize && family(x.p) === a.texture; }, 'Different size', 'More or less parting space');
    var bundles = pool.filter(function (p) { return p.k === 'deal'; });
    if (a.l_use === 'sewin' || a.l_use === 'wig') {
      var self = this;
      var deals = bundles.map(function (p) { var sc = new Scored(p, pickVariant(p, (a.length || 18) + 2)); self.baseline(sc); self.texScore(sc, a.texture, 50); if (a.quality === 'raw' ? lower(p.q) === 'raw' : lower(p.q) === 'virgin') sc.add(18); if (lower(p.cf) === 'blonde') sc.add(-40); return sc; });
      this.rank(deals);
      if (deals[0] && family(deals[0].p) === a.texture) take(deals, function () { return true; }, 'Pair it with', 'Matching bundle deal in your texture');
    }
    take(list, function () { return true; }, 'Also a match', 'Another strong fit');
    return { persona: ['The Finishing Touch', 'The piece that makes an install look like it grew there.'], primary: top, alts: alts.slice(0, 3), addons: ['edge'], browse: this.cfg.browse && this.cfg.browse.lace };
  };

  Quiz.prototype.recExt = function (pool, a) {
    var self = this, t = a.e_type;
    var items = pool.filter(function (p) { return p.k === t; });
    var nat = a.e_nat;
    var scored = items.map(function (p) {
      var v = pickVariant(p, a.e_len || 18);
      var sc = new Scored(p, v), h = lower(p.h), f = family(p);
      self.baseline(sc);
      if (t === 'clipin' || t === 'tapein') {
        var textured = /kinky|afro|jerry|yaki|textured|3b|3c|4a|4b|blowout/.test(h);
        if (nat === 'straight' || nat === 'wavy') {
          if (textured) sc.add(-60); else sc.add(24, 'Silky straight to blend with smoother hair');
          if (/invisible/.test(h)) sc.add(8, 'Invisible weft — the thinnest, flattest clip we make');
          if (/seamless/.test(h)) sc.add(6, 'Seamless silicone weft — lies flat, no bulk');
        }
        if (nat === 'curly') { if (/jerry|3b-3c|3b/.test(h)) sc.add(46, 'Curl pattern matched to 3A–3C hair'); else if (/kinky-curly|3c-4a/.test(h)) sc.add(26); else if (!textured) sc.add(-160); }
        if (nat === 'coily') { if (/afro-kinky|4b-4c/.test(h)) sc.add(48, 'Coil pattern matched to 4A–4C hair'); else if (/kinky-curly|3c-4a/.test(h)) sc.add(38, 'Kinky curly texture that blends with coils'); else if (/kinky-straight|blowout/.test(h)) sc.add(10); else if (!textured) sc.add(-160); }
        if (nat === 'blowout') { if (/kinky-straight|blowout/.test(h)) sc.add(48, 'Blowout texture — blends with stretched natural hair'); else if (/yaki/.test(h)) sc.add(30, 'Yaki texture — relaxed-hair look'); else if (!textured) sc.add(-10); else sc.add(-20); }
      }
      if (a.e_color) {
        var s = shadeOf(p);
        if (s === a.e_color) sc.add(40, 'Shade-matched: ' + SHADES[a.e_color].label);
        else if ((a.e_color === 'jetblack' && s === 'offblack') || (a.e_color === 'offblack' && s === 'jetblack') || (a.e_color === 'darkbrown' && s === 'chocolate') || (a.e_color === 'chocolate' && s === 'darkbrown')) sc.add(12);
        else sc.add(-40);
      }
      if (a.texture && (t === 'crochet' || t === 'bulk')) self.texScore(sc, a.texture, 44);
      if (a.e_len) { var m = h.match(/-(16|20)(?:-|$)/); var len = m ? +m[1] : maxLen(p, v || p.v[0]); if (len) { if (Math.abs(len - a.e_len) <= 1) sc.add(16, len + '" — ' + self.lenLabel(a.e_len)); else sc.add(-16); } }
      return sc;
    });
    this.rank(scored);
    var top = scored[0];
    if (!top) return null;
    var alts = this.pickAlts(scored, top, function (x) { return x.v ? x.v[2] : x.p.p; });
    var persona = { clipin: ['The Instant Upgrade', 'More length and volume in minutes — and back out before bed.'], tapein: ['The Seamless Blend', 'Flat, discreet extensions that wear for weeks and move like your own hair.'], ponytail: ['The Sleek Snatch', 'Instant length, zero commitment. Wrap, pin and go.'], crochet: ['The Protective Glam', 'All the movement of human hair with the ease of a crochet install.'], bulk: ['The Boho Braid', 'Human hair bulk that makes boho braids look soft, full and expensive.'] }[t] || ['Your Extension Match', ''];
    return { persona: persona, primary: top, alts: alts, browse: this.cfg.browse && this.cfg.browse.ext };
  };

  /* ---------- flow: email + results ---------- */
  Quiz.prototype.finish = function () {
    var self = this;
    this.prefetch();
    storeSet(STORE_KEY, { answers: this.answers, done: false, t: Date.now() });
    track('complete', { path: this.eff(this.answers), answers: this.answers });
    var captured = storeGet(STORE_KEY + ':email');
    if (this.cfg.email && this.cfg.email.enabled && !this.cfg.customer && !captured && !this.emailSkipped) return this.showEmail();
    this.showResults();
  };

  Quiz.prototype.showEmail = function () {
    var e = this.cfg.email;
    this.view = 'email';
    history.pushState({ gnhQuiz: { index: this.index, answers: this.answers, view: 'email' } }, '', cleanUrl());
    this.el.setAttribute('data-view', 'email');
    if (this.bar) this.bar.style.transform = 'scaleX(1)';
    if (this.counter) this.counter.textContent = 'Almost there';
    if (this.backBtn) this.backBtn.hidden = false;
    var html = '<div class="gnhq__q gnhq__email">' +
      '<header class="gnhq__qhead"><p class="gnhq__eyebrow">' + esc(e.eyebrow) + '</p><h2 class="gnhq__title" tabindex="-1">' + esc(e.heading) + '</h2><p class="gnhq__sub">' + esc(e.text) + '</p></header>' +
      '<form class="gnhq__form" data-quiz-email novalidate>' +
      '<label class="gnhq__field"><span class="visually-hidden">Email</span><input type="email" name="email" autocomplete="email" inputmode="email" placeholder="Your email address" required></label>' +
      '<button type="submit" class="gnhq__btn gnhq__btn--gold">' + esc(e.button) + '</button>' +
      '<p class="gnhq__formerr" role="alert" hidden>Please enter a valid email address.</p>' +
      (e.legal ? '<p class="gnhq__legal">' + esc(e.legal) + '</p>' : '') +
      '</form>' +
      '<div class="gnhq__extra"><button type="button" class="gnhq__textlink" data-act="skip-email">' + esc(e.skip) + ' <span aria-hidden="true">&rarr;</span></button></div>' +
      '</div>';
    this.swap(html, { title: e.heading });
  };

  Quiz.prototype.submitEmail = function (form) {
    var self = this;
    var input = form.querySelector('input[type=email]');
    var err = form.querySelector('.gnhq__formerr');
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.hidden = false; input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
    err.hidden = true;
    var btn = form.querySelector('button[type=submit]');
    btn.disabled = true; btn.classList.add('is-loading');
    var a = this.answers, path = this.eff(a);
    var tags = ['hair-quiz', 'quiz-' + path];
    if (a.texture) tags.push('quiz-texture-' + a.texture);
    if (a.w_pri) tags.push('quiz-priority-' + a.w_pri);
    if (a.e_type) tags.push('quiz-ext-' + a.e_type);
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', tags.join(','));
    fd.append('contact[accepts_marketing]', 'true');
    var props = this.profileProps();
    try { if (window.klaviyo && klaviyo.identify) { klaviyo.identify(Object.assign({ email: email }, props)); } } catch (e2) {}
    storeSet(STORE_KEY + ':email', { e: 1, t: Date.now() });
    track('email_submit', { path: path });
    this.email = email;
    var post = fetch('/contact#contact_form', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'text/html' } }).catch(function () {});
    if (this.view === 'results') { form.outerHTML = '<p class="gnhq__formlead">Sent. Your match is on its way to your inbox.</p>'; post.then(function () { self.sendMatch(); }); return; }
    post.then(function () { if (self.view === 'email') self.showResults(); });
    setTimeout(function () { if (self.view === 'email') self.showResults(); }, 2500);
  };

  Quiz.prototype.profileProps = function () {
    var a = this.answers, p = {};
    p['Hair Quiz Path'] = this.eff(a);
    if (a.texture) p['Hair Quiz Texture'] = FAMILY_NAMES[a.texture];
    if (a.length) p['Hair Quiz Length'] = a.length + '"';
    if (a.w_pri) p['Hair Quiz Priority'] = a.w_pri;
    if (a.w_exp) p['Hair Quiz Experience'] = a.w_exp;
    if (a.w_color) p['Hair Quiz Color'] = a.w_color;
    if (a.w_budget) p['Hair Quiz Budget'] = a.w_budget;
    if (a.quality) p['Hair Quiz Grade'] = a.quality;
    if (a.lace) p['Hair Quiz Lace'] = a.lace;
    if (a.b_finish) p['Hair Quiz Finish'] = a.b_finish;
    if (a.e_type) p['Hair Quiz Extension Type'] = a.e_type;
    return p;
  };

  Quiz.prototype.showResults = function (fromHistory, isShared) {
    var self = this;
    this.view = 'results';
    if (!fromHistory) history.pushState({ gnhQuiz: { answers: this.answers, view: 'results' } }, '', isShared ? location.pathname + location.search : cleanUrl());
    this.el.setAttribute('data-view', 'loading');
    if (this.bar) this.bar.style.transform = 'scaleX(1)';
    if (this.counter) this.counter.textContent = 'Your match';
    var lines = this.cfg.loading || ['Reading your answers', 'Checking what’s in stock', 'Styling your match'];
    this.stage.innerHTML = '<div class="gnhq__loading" role="status"><div class="gnhq__orb" aria-hidden="true"></div><p class="gnhq__eyebrow">One moment</p><ul class="gnhq__steps">' + lines.map(function (l, i) { return '<li style="--i:' + i + '">' + esc(l) + '</li>'; }).join('') + '</ul></div>';
    var minWait = new Promise(function (r) { setTimeout(r, REDUCED || fromHistory ? 0 : 1900); });
    Promise.all([this.prefetch(), minWait]).then(function () {
      var rec = self.recommend();
      self.rec = rec;
      storeSet(STORE_KEY, { answers: self.answers, done: true, t: Date.now() });
      self.el.setAttribute('data-view', 'results');
      self.stage.innerHTML = self.renderResults(rec);
      var h = $('.gnhq__rtitle', self.stage);
      if (h) h.focus({ preventScroll: true });
      var top = self.el.getBoundingClientRect().top + window.pageYOffset - self.headerOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: REDUCED ? 'auto' : 'smooth' });
      self.updateSetTotal();
      self.bindSticky();
      if (rec) {
        self.klProps = self.matchProps(rec);
        track('results', { path: self.eff(self.answers), match: rec.primary.p.h, alternates: rec.alts.map(function (x) { return x.sc.p.h; }) });
        self.sendMatch();
      }
    });
  };

  /* Everything the "Completed Hair Quiz" Klaviyo event needs to rebuild the
     result in an email: the match, the complete look (bundles), alternates,
     reasons, and a link that reopens this exact result. */
  Quiz.prototype.matchProps = function (rec) {
    var self = this;
    var props = this.profileProps();
    var abs = function (u) {
      if (!u) return '';
      u = String(u).replace(/([?&])width=\d+/, '$1width=600');
      return u.indexOf('//') === 0 ? 'https:' + u : u;
    };
    var link = function (q, v) { return location.origin + q.u + (v ? '?variant=' + v[0] : ''); };
    var item = function (sc, extra) {
      var q = sc.p, v = sc.v;
      var o = { Title: q.t, URL: link(q, v), ImageURL: abs(q.i), Price: self.money(v ? v[2] : q.p), Variant: v ? v[1].join(' / ') : '', Spec: self.spec(q) };
      for (var k in extra || {}) o[k] = extra[k];
      return o;
    };
    var top = rec.primary;
    var m = item(top);
    props['Hair Quiz Match'] = m.Title;
    props['Hair Quiz Match URL'] = m.URL;
    props.MatchTitle = m.Title;
    props.MatchURL = m.URL;
    props.MatchImage = m.ImageURL;
    props.MatchPrice = m.Price;
    props.MatchVariant = m.Variant;
    props.MatchSpec = m.Spec;
    props.MatchHandle = top.p.h;
    props.Persona = rec.persona[0];
    props.PersonaLine = rec.persona[1] || '';
    props.Why = (top.why || []).slice().sort(function (x, y) { return y.n - x.n; }).map(function (w) { return w.t; }).filter(function (t, i, arr) { return arr.indexOf(t) === i; }).slice(0, 3);
    props.Path = this.eff(this.answers);
    props.ResultsURL = location.origin + location.pathname + '?match=' + encodeURIComponent(this.encode(this.answers));
    var value = (top.v ? top.v[2] : top.p.p) || 0;
    props.Set = [];
    if (rec.set) {
      value = 0;
      rec.set.forEach(function (it) {
        if (it.addon || !it.sc || !it.sc.v || !it.checked || !it.sc.v[3]) return;
        props.Set.push(item(it.sc, { Role: it.role || '' }));
        value += it.sc.v[2];
      });
      props.SetTotal = this.money(value);
    }
    props.Alternates = (rec.alts || []).map(function (alt) { return item(alt.sc, { Label: alt.label || '', Note: alt.note || '' }); });
    props.$value = Math.round(value) / 100;
    return props;
  };

  /* Klaviyo drops events from anonymous visitors, so this is re-sent after an
     email is captured on the results page. */
  Quiz.prototype.sendMatch = function () {
    if (!this.klProps) return;
    try { if (window.klaviyo && klaviyo.track) klaviyo.track('Completed Hair Quiz', this.klProps); } catch (e) {}
  };

  Quiz.prototype.money = function (cents) {
    var cur = this.cfg.currency || 'USD';
    try { return new Intl.NumberFormat(this.cfg.locale || 'en-US', { style: 'currency', currency: cur, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  Quiz.prototype.summary = function () {
    var self = this, a = this.answers, steps = this.steps(), out = [];
    steps.forEach(function (q, i) {
      if (q.id === 'path' || q.id === 'decide' || a[q.id] == null) return;
      var o = q.options.filter(function (x) { return String(x.v) === String(a[q.id]); })[0];
      if (!o) return;
      var lab = q.id === 'length' && o.desc ? o.desc.replace(/\s/g, '') : o.label;
      out.push('<button type="button" class="gnhq__chip" data-act="edit" data-index="' + i + '" aria-label="Change ' + esc(self.text(q.title)) + ' (' + esc(lab) + ')">' + esc(lab) + '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 10l1-3 5-5 2 2-5 5z" fill="none" stroke="currentColor" stroke-width="1"/></svg></button>');
    });
    return out.join('');
  };

  Quiz.prototype.variantSelect = function (sc, uid) {
    var p = sc.p;
    if (!p.v || p.v.length < 2) return '';
    var self = this;
    var opts = p.v.map(function (v) {
      var label = v[1].join(' / ');
      return '<option value="' + v[0] + '"' + (sc.v && v[0] === sc.v[0] ? ' selected' : '') + (v[3] ? '' : ' disabled') + ' data-price="' + v[2] + '">' + esc(label) + (v[3] ? '' : ' — sold out') + '</option>';
    }).join('');
    var name = (p.o || []).join(' / ') || 'Option';
    return '<label class="gnhq__select"><span>' + esc(name) + '</span><select data-variant-select data-uid="' + uid + '">' + opts + '</select><svg viewBox="0 0 12 8" aria-hidden="true"><path d="M1 1.5l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.3"/></svg></label>';
  };

  Quiz.prototype.stars = function (p) {
    if (!p.rt) return '';
    var pct = clamp(p.rt / 5 * 100, 0, 100);
    return '<span class="gnhq__stars" aria-label="Rated ' + p.rt.toFixed(1) + ' out of 5' + (p.rc ? ', ' + p.rc + ' reviews' : '') + '"><span class="gnhq__stars-fill" style="width:' + pct + '%"></span></span>' + (p.rc ? '<span class="gnhq__rc">' + p.rc + ' reviews</span>' : '');
  };

  Quiz.prototype.spec = function (p) {
    var bits = [];
    var f = family(p); if (f) bits.push(p.tx || FAMILY_NAMES[f]);
    if (p.q) bits.push(p.q);
    if (p.lt) bits.push(p.lt + ' lace');
    if (p.ls && p.ls.length && p.k !== 'wig') bits.push(p.ls.join(' / '));
    (p.ws || []).forEach(function (w) { if (bits.length < 4) bits.push(w); });
    if (p.cf && p.cf !== 'Black') bits.push(p.cf);
    return bits.slice(0, 4).join(' · ');
  };

  Quiz.prototype.renderResults = function (rec) {
    var self = this, a = this.answers;
    this.uids = {};
    if (!rec) {
      return '<div class="gnhq__empty"><p class="gnhq__eyebrow">Nearly there</p><h2 class="gnhq__rtitle" tabindex="-1">We couldn’t find an exact match in stock today.</h2><p class="gnhq__sub">Try a neighbouring texture or length — or browse everything in this category.</p><div class="gnhq__ractions"><button type="button" class="gnhq__btn gnhq__btn--gold" data-act="retake">Retake the quiz</button><a class="gnhq__textlink" href="' + esc(this.cfg.browse && this.cfg.browse.all || '/collections/all') + '">Browse all hair &rarr;</a></div></div>';
    }
    var top = rec.primary, p = top.p;
    var uid = this.uid(top);
    var why = top.why.sort(function (x, y) { return y.n - x.n; }).map(function (w) { return w.t; }).filter(function (t, i, arr) { return arr.indexOf(t) === i; }).slice(0, 4);
    var html = '';
    html += '<section class="gnhq__reveal" aria-labelledby="gnhq-rt">';
    html += '<p class="gnhq__eyebrow">' + esc(this.cfg.resultsEyebrow || 'Your Hair Match') + '</p>';
    html += '<h2 class="gnhq__rtitle" id="gnhq-rt" tabindex="-1">' + esc(rec.persona[0]).replace(/^(The )?(.*?)(\s\S+)$/, function (m, the, mid, last) { return (the || '') + mid + ' <em>' + last.trim() + '</em>'; }) + '</h2>';
    if (rec.persona[1]) html += '<p class="gnhq__rsub">' + esc(rec.persona[1]) + '</p>';
    html += '<div class="gnhq__chips"><span class="gnhq__chips-label">Based on</span>' + this.summary() + '</div>';
    html += '</section>';

    /* hero match */
    html += '<article class="gnhq__match" data-uid="' + uid + '">';
    html += '<div class="gnhq__gallery">';
    html += '<span class="gnhq__badge">Top match</span>';
    if (p.i) html += '<img class="gnhq__gimg" src="' + esc(p.i) + '" alt="' + esc(p.t) + '" width="900" height="1125">';
    if (p.i2) html += '<img class="gnhq__gimg gnhq__gimg--2" src="' + esc(p.i2) + '" alt="" loading="lazy" width="900" height="1125">';
    html += '</div>';
    html += '<div class="gnhq__minfo">';
    html += '<p class="gnhq__spec">' + esc(this.spec(p)) + '</p>';
    html += '<h3 class="gnhq__mtitle"><a href="' + esc(p.u) + (top.v ? '?variant=' + top.v[0] : '') + '" data-track-link>' + esc(p.t) + '</a></h3>';
    html += '<div class="gnhq__rating">' + this.stars(p) + '</div>';
    html += '<p class="gnhq__whyh">Why it’s your match</p><ul class="gnhq__why">' + why.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>';
    if (rec.set) {
      html += this.renderSet(rec);
    } else {
      html += this.variantSelect(top, uid);
      html += '<div class="gnhq__buy"><span class="gnhq__price" data-price-for="' + uid + '">' + this.money(top.v ? top.v[2] : p.p) + '</span>';
      html += '<button type="button" class="gnhq__btn gnhq__btn--gold gnhq__btn--wide" data-act="add" data-uid="' + uid + '"' + (top.v && !top.v[3] ? ' disabled' : '') + '>' + (top.v && !top.v[3] ? 'Sold out' : 'Add to bag') + '</button></div>';
      html += this.renderAddons(rec);
    }
    html += '<p class="gnhq__trust">' + esc(this.cfg.trust || '') + '</p>';
    html += '<a class="gnhq__textlink" href="' + esc(p.u) + (top.v ? '?variant=' + top.v[0] : '') + '">View full details <span aria-hidden="true">&rarr;</span></a>';
    html += '</div></article>';

    /* alternatives */
    if (rec.alts && rec.alts.length) {
      html += '<section class="gnhq__alts" aria-labelledby="gnhq-alts"><div class="gnhq__altshead"><p class="gnhq__eyebrow">Also matched to you</p><h3 id="gnhq-alts" class="gnhq__h3">More ways to wear it</h3></div><div class="gnhq__altgrid">';
      rec.alts.forEach(function (alt) {
        var s = alt.sc, q = s.p, id = self.uid(s);
        html += '<article class="gnhq__card" data-uid="' + id + '">';
        html += '<a class="gnhq__cmedia" href="' + esc(q.u) + (s.v ? '?variant=' + s.v[0] : '') + '"><span class="gnhq__clabel">' + esc(alt.label) + '</span>' + (q.i ? '<img src="' + esc(q.i) + '" alt="' + esc(q.t) + '" loading="lazy" width="600" height="750">' : '') + '</a>';
        html += '<div class="gnhq__cbody"><p class="gnhq__cnote">' + esc(alt.note) + '</p><h4 class="gnhq__ctitle"><a href="' + esc(q.u) + (s.v ? '?variant=' + s.v[0] : '') + '">' + esc(q.t) + '</a></h4>';
        html += '<p class="gnhq__cspec">' + esc(self.spec(q)) + '</p>';
        html += self.variantSelect(s, id);
        html += '<div class="gnhq__cbuy"><span class="gnhq__price" data-price-for="' + id + '">' + self.money(s.v ? s.v[2] : q.p) + '</span><button type="button" class="gnhq__btn gnhq__btn--line" data-act="add" data-uid="' + id + '">Add to bag</button></div>';
        html += '</div></article>';
      });
      html += '</div></section>';
    }

    /* closing actions */
    html += '<section class="gnhq__close">';
    html += '<div class="gnhq__ractions">';
    html += '<button type="button" class="gnhq__btn gnhq__btn--line" data-act="retake">Retake the quiz</button>';
    html += '<button type="button" class="gnhq__btn gnhq__btn--line" data-act="share">Share my match</button>';
    if (rec.browse) html += '<a class="gnhq__textlink" href="' + esc(rec.browse.url) + '">' + esc(rec.browse.label) + ' <span aria-hidden="true">&rarr;</span></a>';
    html += '</div>';
    if (this.cfg.email && this.cfg.email.enabled && !this.cfg.customer && !storeGet(STORE_KEY + ':email')) {
      html += '<form class="gnhq__form gnhq__form--inline" data-quiz-email novalidate><p class="gnhq__formlead">Email me this match — plus first access to new drops.</p><label class="gnhq__field"><span class="visually-hidden">Email</span><input type="email" name="email" autocomplete="email" placeholder="Your email address" required></label><button type="submit" class="gnhq__btn gnhq__btn--gold">Email my match</button><p class="gnhq__formerr" role="alert" hidden>Please enter a valid email address.</p></form>';
    }
    html += '</section>';

    /* mobile sticky buy bar */
    if (!rec.set) html += '<div class="gnhq__sticky" data-sticky hidden><div class="gnhq__sticky-info"><span class="gnhq__sticky-t">' + esc(p.t) + '</span><span class="gnhq__price" data-price-for="' + uid + '">' + this.money(top.v ? top.v[2] : p.p) + '</span></div><button type="button" class="gnhq__btn gnhq__btn--gold" data-act="add" data-uid="' + uid + '">Add to bag</button></div>';
    else html += '<div class="gnhq__sticky" data-sticky hidden><div class="gnhq__sticky-info"><span class="gnhq__sticky-t">Your complete look</span><span class="gnhq__price" data-set-total-mirror></span></div><button type="button" class="gnhq__btn gnhq__btn--gold" data-act="add-set">Add the look</button></div>';
    return html;
  };

  Quiz.prototype.uid = function (sc) {
    this._n = (this._n || 0) + 1;
    var id = 'm' + this._n;
    this.uids[id] = sc;
    return id;
  };

  Quiz.prototype.addonProduct = function (key) { return (this.cfg.addons || {})[key]; };

  Quiz.prototype.renderAddons = function (rec) {
    var self = this;
    var list = (rec.addons || []).map(function (k) { return self.addonProduct(k); }).filter(Boolean);
    if (!list.length) return '';
    return '<div class="gnhq__addons"><p class="gnhq__whyh">Finish the look</p>' + list.map(function (ad) {
      return '<label class="gnhq__addon"><input type="checkbox" data-addon="' + ad.variant + '"><img src="' + esc(ad.image) + '" alt="" width="80" height="80" loading="lazy"><span class="gnhq__addon-t">' + esc(ad.title) + '<small>' + esc(ad.note || '') + '</small></span><span class="gnhq__addon-p">+ ' + self.money(ad.price) + '</span></label>';
    }).join('') + '</div>';
  };

  Quiz.prototype.renderSet = function (rec) {
    var self = this;
    var html = '<div class="gnhq__set" data-set><p class="gnhq__whyh">Your complete look</p><ul class="gnhq__setlist">';
    rec.set.forEach(function (it, i) {
      if (it.addon) {
        var ad = self.addonProduct(it.addon);
        if (!ad) return;
        html += '<li class="gnhq__setrow gnhq__setrow--addon"><label><input type="checkbox" data-set-toggle data-variant="' + ad.variant + '" data-price="' + ad.price + '"' + (it.checked ? ' checked' : '') + '><span class="gnhq__setbox" aria-hidden="true"></span><img src="' + esc(ad.image) + '" alt="" width="64" height="64" loading="lazy"><span class="gnhq__setinfo"><span class="gnhq__setrole">Optional</span><span class="gnhq__sett">' + esc(ad.title) + '</span></span><span class="gnhq__setp">' + self.money(ad.price) + '</span></label></li>';
        return;
      }
      var s = it.sc, q = s.p, v = s.v;
      if (!v) return;
      var id = self.uid(s);
      var variantLabel = v[1].join(' / ');
      html += '<li class="gnhq__setrow" data-uid="' + id + '"><label><input type="checkbox" data-set-toggle data-variant="' + v[0] + '" data-price="' + v[2] + '"' + (it.checked && v[3] ? ' checked' : '') + (v[3] ? '' : ' disabled') + '><span class="gnhq__setbox" aria-hidden="true"></span>' + (q.i ? '<img src="' + esc(q.i) + '" alt="" width="64" height="64" loading="lazy">' : '') + '<span class="gnhq__setinfo"><span class="gnhq__setrole">' + esc(it.role || '') + '</span><span class="gnhq__sett">' + esc(q.t) + '</span><span class="gnhq__setv">' + esc(variantLabel) + (v[3] ? '' : ' · sold out') + '</span>' + (it.note ? '<span class="gnhq__setnote">' + esc(it.note) + '</span>' : '') + '</span><span class="gnhq__setp">' + self.money(v[2]) + '</span></label></li>';
    });
    html += '</ul><div class="gnhq__buy"><span class="gnhq__price gnhq__price--total"><small>Total</small><span data-set-total></span></span><button type="button" class="gnhq__btn gnhq__btn--gold gnhq__btn--wide" data-act="add-set">Add the complete look</button></div>';
    html += '<p class="gnhq__setfoot">Untick anything you already have. Lengths are pre-selected from your answers — change them on each product page.</p></div>';
    return html;
  };

  Quiz.prototype.updateSetTotal = function () {
    var set = $('[data-set]', this.stage);
    if (!set) return;
    var total = 0, n = 0;
    $$('[data-set-toggle]', set).forEach(function (c) { if (c.checked) { total += +c.getAttribute('data-price'); n++; } });
    var t = this.money(total);
    $$('[data-set-total], [data-set-total-mirror]', this.stage).forEach(function (el) { el.textContent = t; });
    $$('[data-act="add-set"]', this.stage).forEach(function (b) { b.disabled = n === 0; });
  };

  Quiz.prototype.onVariantChange = function (sel) {
    var uid = sel.getAttribute('data-uid');
    var sc = this.uids[uid];
    if (!sc) return;
    var id = +sel.value;
    var v = sc.p.v.filter(function (x) { return x[0] === id; })[0];
    if (!v) return;
    sc.v = v;
    var self = this;
    $$('[data-price-for="' + uid + '"]', this.stage).forEach(function (el) { el.textContent = self.money(v[2]); });
    $$('[data-act="add"][data-uid="' + uid + '"]', this.stage).forEach(function (b) { b.disabled = !v[3]; b.textContent = v[3] ? 'Add to bag' : 'Sold out'; });
  };

  Quiz.prototype.bindSticky = function () {
    var sticky = $('[data-sticky]', this.stage);
    var anchor = $('.gnhq__buy', this.stage);
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    if (this._io) this._io.disconnect();
    var close = $('.gnhq__close', this.stage);
    var visible = { buy: true, close: false };
    var update = function () { sticky.hidden = visible.buy || visible.close || window.innerWidth >= 990; };
    this._io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.target === anchor) visible.buy = en.isIntersecting || en.boundingClientRect.top > 0; if (en.target === close) visible.close = en.isIntersecting; });
      update();
    });
    this._io.observe(anchor);
    if (close) this._io.observe(close);
  };

  /* ---------- cart ---------- */
  Quiz.prototype.cartAdd = function (items, btn) {
    var self = this;
    var drawer = document.querySelector('cart-drawer');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Adding…'; }
    items.forEach(function (it) { it.properties = Object.assign({ _source: 'Hair Match quiz' }, it.properties || {}); });
    var body = { items: items };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = label; }
      if (!res.ok || res.j.status) { self.toast(res.j.description || res.j.message || 'Sorry — that couldn’t be added.', true); return; }
      track('add_to_cart', { path: self.eff(self.answers), items: items.map(function (i) { return i.id; }) });
      try { if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gnh-hair-quiz', cartData: res.j }); } catch (e) {}
      if (drawer && drawer.renderContents && res.j.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res.j);
      } else {
        self.toast('Added to your bag.', false, true);
      }
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = label; }
      self.toast('Something went wrong. Please try again.', true);
    });
  };

  Quiz.prototype.addToCart = function (btn) {
    var uid = btn.getAttribute('data-uid');
    var sc = this.uids[uid];
    if (!sc || !sc.v) return;
    var items = [{ id: sc.v[0], quantity: 1 }];
    var card = btn.closest('.gnhq__minfo');
    if (card) $$('[data-addon]', card).forEach(function (c) { if (c.checked) items.push({ id: +c.getAttribute('data-addon'), quantity: 1 }); });
    this.cartAdd(items, btn);
  };

  Quiz.prototype.addSet = function (btn) {
    var set = $('[data-set]', this.stage);
    if (!set) return;
    var map = {};
    $$('[data-set-toggle]', set).forEach(function (c) { if (c.checked) { var id = +c.getAttribute('data-variant'); map[id] = (map[id] || 0) + 1; } });
    var items = Object.keys(map).map(function (id) { return { id: +id, quantity: map[id] }; });
    if (items.length) this.cartAdd(items, btn);
  };

  Quiz.prototype.toast = function (msg, isError, withCart) {
    var t = $('.gnhq__toast', this.el);
    if (!t) { t = document.createElement('div'); t.className = 'gnhq__toast'; t.setAttribute('role', 'status'); this.el.appendChild(t); }
    t.innerHTML = esc(msg) + (withCart ? ' <a href="' + ((window.routes && routes.cart_url) || '/cart') + '">View bag</a>' : '');
    t.classList.toggle('is-error', !!isError);
    t.classList.add('is-on');
    clearTimeout(this._tt);
    this._tt = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
  };

  /* ---------- share / encode ---------- */
  Quiz.prototype.encode = function (a) {
    return Object.keys(a).map(function (k) { return k + '.' + a[k]; }).join('~');
  };
  Quiz.prototype.decode = function (s) {
    try {
      var out = {};
      s.split('~').forEach(function (pair) { var i = pair.indexOf('.'); if (i < 1) return; var k = pair.slice(0, i), v = pair.slice(i + 1); out[k] = /^\d+$/.test(v) ? +v : v; });
      return out.path ? out : null;
    } catch (e) { return null; }
  };
  Quiz.prototype.share = function (btn) {
    var url = location.origin + location.pathname + '?match=' + encodeURIComponent(this.encode(this.answers));
    var title = this.rec ? this.rec.persona[0] : 'My Hair Match';
    var self = this;
    track('share', {});
    if (navigator.share) { navigator.share({ title: title + ' — GoNaked Hair', text: 'I took the GoNaked Hair Match quiz. This is my match:', url: url }).catch(function () {}); return; }
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () { self.toast('Link copied — share your match anywhere.'); }).catch(function () { window.prompt('Copy your match link:', url); });
  };

  /* ---------- boot ---------- */
  function init() { $$('[data-gnh-quiz]').forEach(function (el) { if (!el.__gnhq) el.__gnhq = new Quiz(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.GnhHairQuiz = { init: init, _family: family, _pick: pickVariant, _inches: inches };
})();